export default "__VITE_ASSET__e26b6a94__"